// extracted by mini-css-extract-plugin
module.exports = {"error":"LoadingPage-module_error_1dnXW"};